// extracted by mini-css-extract-plugin
export default {"contextMenu":"OrganisationContextMenu_contextMenu__GXoSt","contextMenuItem":"OrganisationContextMenu_contextMenuItem__8mFgF"};